export enum InvoiceActionType {
  Cancel = 'cancel',
  CreateCreditNote = 'createCreditNote',
  Duplicate = 'duplicate',
  MarkAsSent = 'markAsSent',
  OpenInZervant = 'openInZervant',
  RegisterPayment = 'registerPayment',
  SendPaymentReminder = 'sendPaymentReminder',
  Share = 'share',
  UnmarkAsSent = 'unmarkAsSent',
}
